import { render, staticRenderFns } from "./Top5List.vue?vue&type=template&id=770a3b24&scoped=true"
import script from "./Top5List.vue?vue&type=script&lang=js"
export * from "./Top5List.vue?vue&type=script&lang=js"
import style0 from "./Top5List.vue?vue&type=style&index=0&id=770a3b24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770a3b24",
  null
  
)

export default component.exports